/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const Forklift = createLucideIcon("forklift", [
  ["path", { d: "M12 12H5a2 2 0 0 0-2 2v5", key: "7zsz91" }],
  ["path", { d: "M15 19h7", key: "1askl3" }],
  ["path", { d: "M16 19V2", key: "1gf9nk" }],
  [
    "path",
    {
      d: "M6 12V7a2 2 0 0 1 2-2h2.172a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 16 10.828",
      key: "enx9tf"
    }
  ],
  ["path", { d: "M7 19h4", key: "fumhkk" }],
  ["circle", { cx: "13", cy: "19", r: "2", key: "wjnkru" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }]
]);

export { Forklift as default };
//# sourceMappingURL=forklift.js.map
